import { render, staticRenderFns } from "./SkyCheckbox.vue?vue&type=template&id=18af28bb"
import script from "./SkyCheckbox.vue?vue&type=script&lang=js"
export * from "./SkyCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports